// extracted by mini-css-extract-plugin
module.exports = {"spec_table":"specs_spec_table__gMf4q","spec_title":"specs_spec_title__GzaES","spec_value":"specs_spec_value__FwLi9","see_more":"specs_see_more__TPMFL"};